import { styled } from '@mui/material';
import { WidthProvider, Responsive } from 'react-grid-layout';
import 'react-resizable/css/styles.css';
import 'react-grid-layout/css/styles.css';
export const SortablePanelsGridLayout = styled(WidthProvider(Responsive))(({ theme }) => {
    const borderColor = theme.palette.mode === 'dark'
        ? theme.palette.common.white
        : theme.palette.action.active;
    return {
        '& .react-grid-item': {
            overflow: 'hidden',
            '& > .react-resizable-handle': {
                '&::after': {
                    width: 8,
                    height: 8,
                    borderBottomColor: borderColor,
                    borderTopColor: borderColor,
                    borderLeftColor: borderColor,
                    borderRightColor: borderColor,
                },
            },
        },
    };
});
